export default __webpack_public_path__ + "static/beautydoc-screen-98efce4e82ca9fe8a683d157cc7cfcdf.png";